import { VEHICLE_SEARCH_URL } from "../constants";
export const getSearchAPIData = async ()=>{
    const response = await fetch(VEHICLE_SEARCH_URL).then((res)=>res.json());
    return response;
};
